import React from 'react';
import {
  Badge,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  Link,
  ListItemText,
  Avatar,
  Button
} from '@mui/material';
import {
  BarChart as BarChartIcon,
  FeedbackOutlined as FeedbackIcon,
  Business as BusinessIcon,
  Group as GroupIcon,
  Layers as LayersIcon,
  // Settings as SettingsIcon,
  Notes as NotesIcon,
  WorkOutline as WorkOutlineIcon
} from '@mui/icons-material';
import { useHistory, NavLink } from 'react-router-dom';

import { observer } from 'mobx-react-lite';
import useStores from '../../stores/useStores';

const MenuList = () => {
  const { userStore, uiStore } = useStores();
  const { user } = userStore;
  const history = useHistory();

  // TODO remove compatability hack
  const menuItems =
    user && user.group.menu_items ? user.group.menu_items : null;

  const goToSettings = e => {
    e.stopPropagation();
    history.push(`/team/${user.id}`);
    uiStore.setSidebarExpanded(false);
  };

  const items = [
    {
      id: 'nav-prospecting',
      to: '/search',
      icon: <BusinessIcon />,
      label: 'Prospecting',
      isVisible: menuItems.includes('prospecting')
    },
    {
      id: 'nav-projects',
      to: '/project',
      icon: <WorkOutlineIcon />,
      label: 'Projects',
      isVisible: true,
      notificationCount: userStore.notifications.filter(
        n => n.type === 'project'
      ).length
    },
    {
      id: 'nav-team',
      to: '/team',
      icon: <GroupIcon />,
      label: 'Team',
      isVisible: menuItems.includes('team_manager')
    },
    {
      id: 'nav-documents',
      to: {
        pathname: `/documents/OTEwMTcxOTc2NTA1OTY1NjQyODQxMzA1MTg3ODAwNjk3NTg5MzUwMDExNDYwMzk0MjgzOTQyNDA5NzU3NDk0MDI4NzE0MjMxOTAzODE5NDYwOTY3ODg4NDU4Njc5NzQy`,
        state: { modal: true }
      },
      icon: <NotesIcon />,
      label: 'Documents',
      isVisible: menuItems.includes('documents')
    },
    {
      id: 'nav-editor',
      to: '/dataeditor',
      icon: <LayersIcon />,
      label: 'Editor',
      isVisible: menuItems.includes('editor')
    },
    {
      id: 'nav-analytics',
      to: '/analytics',
      icon: <BarChartIcon />,
      label: 'Events',
      isVisible: menuItems.includes('analytics')
    },
    {
      id: 'nav-feedback',
      to: '#',
      onClick: () => uiStore.setFeedbackModalOpen(true),
      icon: <FeedbackIcon />,
      label: 'Feedback',
      isVisible: menuItems.includes('feedback')
    }
    /*
    {
      id: 'nav-logout',
      to: '/',
      onClick: handleLogout,
      icon: <ExitToAppIcon />,
      label: 'Sign out',
      isVisible: true
    }
    */
  ].filter(menuItem => menuItem.isVisible);

  return (
    <div className="sidebar--menu">
      <List component="nav">
        {items.map(item => (
          <ListItem
            id={item.id}
            key={item.id}
            button
            component={typeof item.onClick !== 'undefined' ? Link : NavLink}
            onClick={item.onClick}
            to={item.to}
          >
            <ListItemIcon className="list-item-icon">
              <Badge badgeContent={item.notificationCount} color="primary">
                {item.icon}
              </Badge>
            </ListItemIcon>
            <ListItemText
              className="list-item-text"
              primary={item.label}
              primaryTypographyProps={{ noWrap: true }}
            />
            <ListItemSecondaryAction />
          </ListItem>
        ))}
        <ListItem
          id="nav-user-profile"
          onClick={() => uiStore.setSidebarExpanded(true)}
          onBlur={() => uiStore.setSidebarExpanded(false)}
          button
          className="list-item-profile"
          style={{
            paddingLeft: 8,
            paddingBottom: 0
          }}
        >
          <ListItemIcon className="list-item-icon">
            <Avatar
              style={{
                background: '#2c2c2c',
                opacity: 1
              }}
              // src={avatarUrl}
              src={userStore.avatar}
            >
              {user.email && user.email.substring(0, 2)}
            </Avatar>
          </ListItemIcon>
          <ListItemText
            className="list-item-text"
            primary={
              <Box onClick={goToSettings}>{user.firstname || user.email}</Box>
            }
            secondary={
              <Button
                sx={{
                  color: '#fff',
                  fontWeight: 500,
                  textTransform: 'none',
                  padding: 0
                }}
                onClick={goToSettings}
              >
                Manage Account
              </Button>
            }
            primaryTypographyProps={{ noWrap: true }}
            // secondaryTypographyProps={{ color: 'white' }}
          />
          <ListItemSecondaryAction>
            {/* {false && (
              <IconButton
                style={{
                  color: '#fff'
                }}
                component="span"
                size="large"
              >
                <SettingsIcon />
              </IconButton>
            )} */}
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    </div>
  );
};

export default observer(MenuList);
